import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "review-star" }
const _hoisted_2 = {
  style: { width: '16px', height: '15px' },
  viewBox: "0 0 14 13",
  xmlns: "http://www.w3.org/2000/svg",
  part: "star-svg"
}
const _hoisted_3 = ["id"]
const _hoisted_4 = ["offset", "stop-color"]
const _hoisted_5 = ["offset", "stop-color"]
const _hoisted_6 = ["stop-color"]
const _hoisted_7 = ["fill"]

import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewStar',
  props: {
  filledStar: {
    type: Number,
    default: 1,
  },
  fillColor: {
    type: String,
    default: '#000000',
  },
  emptyColor: {
    type: String,
    default: '#CED3D8',
  },
},
  setup(__props) {

const props = __props



const fillPercentage = computed(() => {
  return `${Math.max(0, Math.min(100, props.filledStar * 100))}%`;
});

const gradientId = computed(() => {
  return `star-fill-${Math.floor(Math.random() * 1000000)}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("defs", null, [
        _createElementVNode("linearGradient", {
          id: _unref(gradientId),
          x1: "0%",
          y1: "0%",
          x2: "100%",
          y2: "0%"
        }, [
          _createElementVNode("stop", {
            offset: _unref(fillPercentage),
            "stop-color": props.fillColor
          }, null, 8, _hoisted_4),
          _createElementVNode("stop", {
            offset: _unref(fillPercentage),
            "stop-color": props.emptyColor
          }, null, 8, _hoisted_5),
          _createElementVNode("stop", {
            offset: "100%",
            "stop-color": props.emptyColor
          }, null, 8, _hoisted_6)
        ], 8, _hoisted_3)
      ]),
      _createElementVNode("path", {
        d: "M6.52346 0.500355C6.67111 0.0354989 7.32889 0.0355003 7.47654 0.500356L8.68538 4.3063C8.75132 4.51391 8.94408 4.65494 9.16192 4.65494H13.0975C13.5791 4.65494 13.7823 5.26895 13.3958 5.55624L10.1924 7.93714C10.0211 8.06444 9.94953 8.28641 10.0141 8.4898L11.2331 12.3276C11.38 12.7902 10.8479 13.1698 10.4583 12.8802L7.29826 10.5316C7.1212 10.4 6.8788 10.4 6.70174 10.5316L3.54173 12.8802C3.15212 13.1698 2.61997 12.7902 2.76692 12.3276L3.98587 8.4898C4.05047 8.28641 3.97886 8.06444 3.80759 7.93714L0.604199 5.55624C0.217665 5.26895 0.420857 4.65494 0.902462 4.65494H4.83808C5.05592 4.65494 5.24868 4.51391 5.31462 4.3063L6.52346 0.500355Z",
        fill: `url(#${_unref(gradientId)})`
      }, null, 8, _hoisted_7)
    ])),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})